import React, { useEffect, useContext } from 'react'
import { useLocation, withRouter } from 'react-router-dom'
import qs from 'query-string'
import { useTranslation } from 'react-i18next'
import { UserContext } from '../utils/UserContext'
import { PropertyProvider } from '../utils/PropertyContext'
import { loadStripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'
import { SnackbarProvider } from 'notistack'
import Layout from './layout'
import Header from '../header'
import { StepProvider } from '../utils/stepContext'
import LayoutBooking from './LayoutBooking'
import { Context } from '../Store'
import { BookingProvider } from '../utils/BookingContext'

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_TOKEN)

const Content = (props) => {
  const { i18n } = useTranslation()
  const { search } = useLocation()
  const { isLoading, user } = useContext(UserContext)
  const [state] = useContext(Context)
  const { tr } = qs.parse(search)
  useEffect(() => {
    if (!isLoading && state.property.id) {
      const dataLayer = {
        trackCode: tr,
        pageLanguage: i18n.language,
        pageType: props.pageType,
        pageTitle: document.title,
        city: state.property.city,
      }
      if (user.id) {
        dataLayer.visitorLoginState = 'logged-in'
        dataLayer.userId = user.id
        dataLayer.userType = user.type
      } else {
        dataLayer.visitorLoginState = 'logged-out'
      }
    }
  }, [isLoading, state.property])

  if (props.pageType === 'visit') {
    return (
      <StepProvider pageType="visit">
        <SnackbarProvider maxSnack={3}>
          <PropertyProvider id={props.match.params.id} pageType="visit">
            <Elements stripe={stripePromise}>
              <Header />
              <Layout pageType="visit">{props.children}</Layout>
            </Elements>
          </PropertyProvider>
        </SnackbarProvider>
      </StepProvider>
    )
  } else {
    return (
      <StepProvider pageType="booking">
        <SnackbarProvider maxSnack={3}>
          <BookingProvider>
            <Elements stripe={stripePromise}>
              <Header />
              <LayoutBooking>{props.children}</LayoutBooking>
            </Elements>
          </BookingProvider>
        </SnackbarProvider>
      </StepProvider>
    )
  }
}

export default withRouter(Content)
